import { Navigation, Swiper } from "swiper";
import { Chart, DoughnutController, ArcElement } from 'chart.js/auto';

const projectColors = require("../../../tailwind.config.js").theme.colors;
const cutoutPercentage = 80;
const doughnutSize = 300;

export default class SliderAnita {
    chart = null;
    swiper = null;

	static initAll() {
        const sliderBaseContainers = document.querySelectorAll('.slider-anita.swiper');
        if (sliderBaseContainers.length === 0) return;		

        sliderBaseContainers.forEach(container => {
            const sliderAnita = new SliderAnita();

            const config = {
                modules: [Navigation],
                navigation: {
                    nextEl: '.swiper-button-next-anita',
                },
                slidesPerView: 1,
                spaceBetween: 50,
                autoHeight: true,
                allowTouchMove: true,
                grabCursor: true,
                direction: 'horizontal',
                loop: true,
                on: {
                    realIndexChange: () => { 
                        sliderAnita.updateViews();
                    },
                },
            };

			sliderAnita.swiper = new Swiper(container, config);
            sliderAnita.initChartJS();
		});
	}

    updateViews() {
        if (!this.chart) return;

        const percentage = (100 / this.swiper.slides.length) * (this.swiper.realIndex + 1);
        this.chart.data.datasets[0].data = [percentage, 100 - percentage];
        this.chart.update();

        const progressElement = document.querySelector('.slider-anita-progress');
        if(!progressElement) return null;

        const icons = progressElement.querySelectorAll(".icon");
        icons.forEach(icon => {
            if (icon.classList.contains("index-" + this.swiper.realIndex)) {
                icon.style.display = "block";
            } else {
                icon.style.display = "none";
            }
        });
    }

    initChartJS() {
        Chart.register(DoughnutController, ArcElement);

        const doughnutElement = document.querySelector('.slider-anita-progress .doughnut-chart');
        if (!doughnutElement) return;

        this.chart = new Chart(doughnutElement, {
            type: "doughnut",
            data: {
                datasets: [{
                    data: [0, 100],
                    backgroundColor: [
                        projectColors.tertiary,
                        'rgba(227, 227, 227,1)',
                    ],
                    borderWidth: 0,
                }],
            },
            options: {
                responsive: false,
                cutout: cutoutPercentage + '%',
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        enabled: false,
                    },
                    legend: {
                        display: false,
                    },
                },
                events: [],
            },
        });
    
        this.updateViews();
        
        const cutoutPercentageHalf = 100 - (100 - cutoutPercentage) / 2;
        const radius = (doughnutSize * cutoutPercentageHalf) / 100;

        const circlePath = document.querySelector('.slider-anita-progress .circle-path');
        if (!circlePath) return;
        
        circlePath.style.width = radius + "px";
        circlePath.style.height = radius + "px";
    }
}
